<template>
	<div class="topUps">
		<div class="topUps_head">
			<span class="ups_left">充值</span>
			<span class="ups_right" @click="close('czmx')">关闭</span>
		</div>
			<div class="chongzhi">
			  <div class="li" @click="pay(10)" >
			    <span class="count">1000电池</span>
			    <span class="price">售价：10元</span>
			  </div>
			  <div class="li" @click="pay(20)" >
			    <span class="count">2000电池</span>
			    <span class="price">售价：20元</span>
			  </div>
			  <div class="li" @click="pay(30)" >
			    <span class="count">3000电池</span>
			    <span class="price">售价：30元</span>
			  </div>
			  <div class="li" @click="pay(50)" >
			    <span class="count">5000电池</span>
			    <span class="price">售价：50元</span>
			  </div>
			  <div class="li" @click="pay(100)" >
			    <span class="count">1万电池</span>
			    <span class="price">售价：100元</span>
			  </div>
			  <div class="li other" @click="pay('other')">
			    其他金额
			  </div>
			  
			</div>
			
			<div class="otherPrice" v-if="other">
			  <input type='text' @input="handleInput" v-model="money" placeholder='请输入金额' ></input>
			  <span><span v-if="dianChi">{{dianChi}}电池</span></span>
			  <button  @click="paygo">确认</button>
			</div>

			<div class="chongzhi">
				<div class="otherPrice" >
					<input style="width: 100%;" type='text'  v-model="moneym" placeholder='请输入充值码' ></input>
					<button  v-loading="loading"   @click="paygo1" style="margin-top:30px ;width: 60%;">确认</button>
					<div style="font-size: 12px;color: blue;margin-top: 15px;cursor: pointer;" @click="dktb">没有充值卡？马上购买</div>
				  </div>
			</div>
			
		      <transition name="el-zoom-in-bottom">
		        <top-ups-py v-if="payShow" :payShowFc='payShowFc' :otherPrice="otherPrice"></top-ups-py>
		      </transition>			
			
	</div>
</template>

<script>
import qs from "qs"	
import topUpsPy from "@/components/im/topUpsPy"
export default {	
	props:['chongzhi'],
	components:{
		topUpsPy
	},	
  data () {
    return {
		other:false,
	    dianChi:'',
	    otherPrice:'',
	    money:'',		
	    payShow:false,

		loading: false,
		
	  
	   
	    moneym:'',		
	   
    }
  },
  methods:{
	dktb(){
		window.open('https://item.taobao.com/item.htm?ft=t&id=714266377639')
	},
	paygo1(){
	    if(this.moneym==''){
	    	this.$message.error('请输入充值码');
	      return false
	    }
	    this.gopay()
	},
	gopay(){
		this.loading = true
		let params = qs.stringify({
            'rechargeCode':this.moneym,
          })
          this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
          this.$axios.post('/goods/user/Recharge', params)
                .then(res => {
                  if (res.data.resultCode == '0000') {
                    this.loading = false
					this.$message({
					message: res.data.resultInfo,
					type: 'success'
					});
					this.moneym = ''
                  } else {
                    this.loading = false
                    this.$message.error(res.data.resultMsg);
                  }
                }).catch(error => {
                  console.log(error)
                })
	},
	close(data){
  		if (this.chongzhi) {
          this.chongzhi(data);
        }
	},
	pay(data){
	   if(data=="other"){
	      this.other=true
	      this.otherPrice=this.money
	      this.dianChi=this.money*100
	   }else{
	    this.other=false
	    this.dianChi=''
	    this.otherPrice=data
	    this.paygo()
	   }
	},
	handleInput(){
	    let price = this.money;
	    price = price.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
	    price = price.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
	    price = price.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
	    price = price.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
	    if (price.indexOf(".") < 0 && price != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
	        price = parseFloat(price);
	    }
	    this.otherPrice=price
	    this.dianChi=price*100
	},
	paygo(){
	    if(this.otherPrice==''){
	    	this.$message.error('请输入金额');
	      return false
	    }
	    this.payShow=true
	},
	payShowFc(){
		this.payShow=false
	}
  },
  created:function(){
  		
  }  
}	
</script>

<style scoped>
.topUps{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #FFFFFF;
	z-index: 1000;
	overflow: auto;
	padding-top: 40px;
}
.topUps_head{
	background: #F2F6FC;
	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	line-height: 40px;
	padding: 0px 15px;
	overflow: hidden;
}
.ups_left{
	float: left;
	font-weight: bold;
}
.ups_right{
	float: right;
	color: red;
	cursor: pointer;
}


.chongzhi{
	padding-top: 30px;
  margin-left: 1%;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 6px;
}
.chongzhi .li{
  width: 32%;
  margin-left: 1%;
  border: 1px #E33C64 solid;
  text-align: center;
  float: left;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 6px;
}
.chongzhi .li span{line-height: 40px;}
.chongzhi .li .count{
  display: block;
  text-align: center;
  color: #E33C64;
}
.chongzhi .li .price{
  display: block;
  text-align: center;
  color: #E33C64;
}
.chongzhi .other{
  color: #E33C64;
  line-height: 80px;
}

.otherPrice{
  padding:40px 1%;
}
.otherPrice input{
  width: 100%;
  height: 40px;
  border: 1px #dfdfdf solid;
  border-radius: 5px;
  outline: none;
  padding-left: 15px;
}
.otherPrice span{
  display: block;
  text-align: center;
  height: 50px;
  line-height: 50px;
  color: #E33C64;
}
.otherPrice button{
  height: 48px;
  background: #E33C64;
  border: none;
  margin:0 ;
  color: #ffffff;
  font-weight: normal;
  width: 100%;
  
}

</style>





// WEBPACK FOOTER //
// src/components/im/topUpsCZ.vue